import React from 'react';

export default class WarCatCard extends React.Component {
    render() {
        const { war, isNew } = this.props;
        const localImageUrl = war['localImageUrl'];

        const goToNextLevel = this.props.goToNextLevel;

        return (
            <div
                className="card war-card-folder"
                onClick={() => goToNextLevel(this.props.war.WarCatId, this.props.war.CategoryName)}
            >
                {isNew ? <span className="badge badge-primary">New</span> : null}
                <img
                    src={localImageUrl == null ? '' : localImageUrl}
                    className="card-img-top img-fluid"
                    alt=""
                />
                <div className="card-block">
                    <h6>{war.CategoryName}</h6>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/War/WarCatCard.js